// extracted by mini-css-extract-plugin
export default {"clipi":"ResetPasswordPage_clipi__5I90c"};